var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticStyle:{"width":"100%","height":"100%"}},[_c('img',{staticClass:"img",attrs:{"src":"http://group.jiuhangjituan.cn/jiuhangjituan_banner1.png","alt":""}})])
}]

export { render, staticRenderFns }